import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from "react";
import { formatDataGeneral, getAttributeValue, getYearFromDateValue } from "../../utils/utils";
import axios from "../../api/axios";
import APRComment from "./APRComment.js/AprComments";
import APRmemo from "./APRComment.js/APRmemo";

const PROGRAM_ID = "UfMl96n7nnX";
const DATE_ATTRIBUTE = "YfoGKu8N6An";
const EVALUATION_TYPE = "Participatory Monitoring Evaluation";

function getEvaluationDateValue(item) {
  const dateValue = getAttributeValue("Date", item);
  return dateValue && dateValue !== "N/A" ? dateValue : "";
}

function isSelectedYearWithinDate(item, selectedYear) {
  const dateValue = getEvaluationDateValue(item);
  if (!dateValue) {
    return false;
  }

  const dateYear = getYearFromDateValue(dateValue);
  return dateYear === selectedYear;
}

const Table_22 = forwardRef(({ year, district, period, hideTableDis }, ref) => {
  const [tableData, setTableData] = useState([]);

  const selectedYear = useMemo(() => {
    const parsed = parseInt(year, 10);
    return Number.isFinite(parsed) ? parsed : new Date().getFullYear();
  }, [year]);

  useEffect(() => {
    getData();
  }, [selectedYear, district, period]);

  useImperativeHandle(ref, () => ({
    getData: () => ({
      indicator: "Table_22",
      tableData,
    }),
  }));

  async function getData() {
    if (!district) {
      setTableData([]);
      return;
    }

    try {
      const startDate = `${selectedYear}-01-01`;
      const endDate = `${selectedYear}-12-31`;

      const response = await axios.get(
        `/tracker/trackedEntities?orgUnit=${district}&program=${PROGRAM_ID}&filter=${DATE_ATTRIBUTE}:GE:${startDate}:LE:${endDate}&pageSize=5000`,
      );

      const instances = response.data.instances || [];
      const evaluations = (formatDataGeneral(instances, "Evaluation Type", EVALUATION_TYPE) || [])
        .filter((item) => isSelectedYearWithinDate(item, selectedYear));

      const temps = evaluations.map((item, idx) => {
        const findings = getAttributeValue("Findings PME", item);

        return {
          no: idx + 1,
          name: getAttributeValue("Evaluation Name", item),
          policy: getAttributeValue("Policy/Programme/ project involved", item),
          consultant: getAttributeValue("Consultant or resource persons involved", item),
          methodology: getAttributeValue("Methodology used", item),
          findings: findings && findings !== "N/A" ? findings : "",
          recommendations: getAttributeValue("Recommendations", item),
          date: getEvaluationDateValue(item),
        };
      });

      setTableData(temps);
    } catch (err) {
      console.error("Error loading Table 22 data:", err);
      setTableData([]);
    }
  }

  return (
    <div className="col-12">
      <h3>Table 22 – UPDATE ON PARTICIPATORY MONITORING AND EVALUATION (PM&E) TOOLS USED</h3>
      <div className="card">
        <div className="card-header" />
        <div className="card-body">
          <APRmemo
            year={year}
            districtId={district}
            tableCommentedId={`table22-${year}`}
            hideTableDis={hideTableDis}
          />
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead style={{ backgroundColor: "#d4edda", fontWeight: "bold", border: "1px solid #000" }}>
                <tr>
                  <th style={{ border: "1px solid #000", fontWeight: "bold" }}>Name of the PM&E Tool</th>
                  <th style={{ border: "1px solid #000", fontWeight: "bold" }}>Policy/Programme/Project Involved</th>
                  <th style={{ border: "1px solid #000", fontWeight: "bold" }}>Consultant or Resource Persons Involved</th>
                  <th style={{ border: "1px solid #000", fontWeight: "bold" }}>Methodology Used</th>
                  <th style={{ border: "1px solid #000", fontWeight: "bold" }}>Findings</th>
                  <th style={{ border: "1px solid #000", fontWeight: "bold" }}>Recommendations</th>
                </tr>
              </thead>
              <tbody>
                {tableData.length > 0 ? (
                  tableData.map((row, index) => (
                    <tr key={index}>
                      <td style={{ border: "1px solid #000" }}>{row.name}</td>
                      <td style={{ border: "1px solid #000" }}>{row.policy}</td>
                      <td style={{ border: "1px solid #000" }}>{row.consultant}</td>
                      <td style={{ border: "1px solid #000" }}>{row.methodology}</td>
                      <td style={{ border: "1px solid #000" }}>
                        <p style={{ whiteSpace: "pre-line", marginBottom: 0 }}>{row.findings}</p>
                      </td>
                      <td style={{ border: "1px solid #000" }}>{row.recommendations}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" style={{ border: "1px solid #000", textAlign: "center" }}>
                      No PM&E tools found for {selectedYear}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <APRComment
            data={tableData}
            year={year}
            districtId={district}
            tableCommentedId={`table22-${year}`}
            hideTableDis={hideTableDis}
          >
            {({ renderCommentInput, renderCommentList }) => (
              <>
                {renderCommentInput()}
                {renderCommentList()}
              </>
            )}
          </APRComment>
        </div>
      </div>
    </div>
  );
});

export default Table_22;
